export const employersDirectoryEditComponent = {
  template: `
    <employers-directory-main
       type="Edit"
       details="$ctrl.details"
       title="Edit Company"
    >
    </employers-directory-main
    `,
  bindings: {
    details: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-edit/employers-directory-edit.component.js